import React from 'react';
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import PaperCard from './paper-card';

const useStyles = makeStyles(theme => ({
  subHeader: {
    color: 'rgb(255, 255, 255)',
    fontWeight: 550,
    fontSize: 20
  },
  height: {
    height: 80, 
    borderRadius: 20
  },
  paperCardBox: {
    color: '#1F3141'
  },
  colorPositive: {
    color: '#E30C3F'
  },
  colorNegative: {
    color: "#02CDB1"
  }
}));

export default function LitlePaperCard(props) {
    const { title, percentage, theme } = props;
  const classes = useStyles();
  const children = (
    <Box display='flex' justifyContent='space-between' alignItems='center' >
        <Typography component="p" classes={{root: clsx(classes.subHeader, !theme ? classes.paperCardBox : null)}}>
            {title}
        </Typography>
        <Typography 
          component="p" 
          classes={{root: clsx(classes.subHeader, 
          !theme ? classes.paperCardBox : null, 
          parseInt(percentage) > 0 ? classes.colorPositive: classes.colorNegative)}}>
            {percentage +"%"}
        </Typography>
    </Box>
  )
  return (
    <PaperCard
      children={children}
      height={classes.height} 
      theme={theme}
    />
  );
}
